import { CircularProgress } from "@mui/material";
import { Button } from "react-bootstrap";

interface HeaderInfoButtonProps {
  active: boolean;
  label: string;
  count?: string | number;
  isLoading?: boolean;
  onClick: () => void;
}

const HeaderInfoButton = ({
  active,
  label,
  count,
  isLoading,
  onClick,
}: HeaderInfoButtonProps) => {
  return (
    <Button
      variant={active ? "primary" : "light"}
      className="me-4 rounded-0 shadow"
      onClick={() => onClick()}
    >
      <h2 className="text-gray-400">
        {isLoading ? (
          <CircularProgress
            size={40}
            thickness={8}
            sx={{ marginTop: 2 }}
            color="secondary"
          />
        ) : (
          count
        )}
      </h2>
      <p className="m-0">{label}</p>
    </Button>
  );
};
export default HeaderInfoButton;
